import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {ConceptSelection, DisplayField, FieldFilter} from '@twpub/core/models';
import {ContentItem, RefLinkContentParser} from '@twpub/core/services/ref-link-content-parser';
import {SharedStateService} from '@twpub/core/services';

import {AttachmentRenderWrapperComponent} from '@twpub/shared/components/wrappers';
// noinspection ES6PreferShortImport  - causes circular dep if shortened
import {LinkRenderComponent} from '../link-render/link-render.component';
import {LineBreakPipe} from '../../../pipes/line-break.pipe';
import {HighlightPipe} from '../../../pipes/highlight.pipe';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[pub-field-render]',
  templateUrl: './field-render.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AttachmentRenderWrapperComponent, LinkRenderComponent, LineBreakPipe, HighlightPipe]
})
export class FieldRenderComponent implements OnInit, OnChanges {
  @Input() field!: DisplayField;
  highlightTerm?: string;
  title: string = '';

  @Output() conceptSelected = new EventEmitter<ConceptSelection>();
  contentItems: ContentItem[] = [];

  @HostBinding('class') get fieldClass() {
    return 'f f-' + this.field.oid;
  }

  @HostBinding('style') get fieldStyle(): SafeStyle | null {
    if (!this.field.cssStyle) return null;
    return this.sanitizer.bypassSecurityTrustStyle(this.field.cssStyle);
  }

  constructor(private parser: RefLinkContentParser, private sharedStateService: SharedStateService, private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.parseField();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.field) {
      this.parseField();
    }
  }

  private parseField(): void {
    this.title = this.field.title || '';
    this.contentItems = this.parser.parse(this.field.value, this.field.refLinks);
    this.contentItems.forEach((item) => {
      item.isVirtualFile = this.parser.isVirtualFile(item);
      item.fileId = this.parser.getFileId(item);
    });
    this.highlightTerm = this.getFilterValue();
  }

  private getFilterValue(): string | undefined {
    const filters: FieldFilter[] | undefined = this.sharedStateService.sessionObj.fieldFilters;
    if (!filters?.length || !this.field.jsonField) return undefined;
    const filter = filters.find(f => f.fieldKey.jsonField === this.field.jsonField);
    return filter?.values?.[0];
  }

  selectConcept(selection: ConceptSelection) {
    this.conceptSelected.emit(selection);
  }
}
